// extracted by mini-css-extract-plugin
module.exports = {"tag":"_99551c8aa8--tag--x6CLT"};